import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PrefilledFieldShell from './PrefilledFieldShell';
import { resolveFieldMode } from '../requestDraftFieldPolicy';
import { scalarEqualsSnapshot } from '../draftFormUtils';

const FIELDS = [
  { key: 'prefix', label: 'Prefix' },
  { key: 'licenseNumber', label: 'License number' },
  { key: 'issuingCountry', label: 'Issuing country' },
  { key: 'authorityName', label: 'Authority' },
  { key: 'issueDate', label: 'Issue date', type: 'date' },
  { key: 'expiryDate', label: 'Expiry date', type: 'date' },
];

export default function LicenseSection({
  licenseInfo,
  baselineLicense,
  policy,
  onFieldChange,
  forceReadOnly = false,
}) {
  const att = licenseInfo?.attachment;
  const attLabel = att
    ? `${att.originalName || 'Attachment'} (#${att.id})`
    : '—';

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Header className="fw-semibold">Selected license</Card.Header>
      <Card.Body>
        <Row>
          {FIELDS.map(({ key, label, type }) => {
            const path = `licenseInfo.${key}`;
            const mode = forceReadOnly
              ? 'readOnly'
              : resolveFieldMode(path, policy);
            const cur = licenseInfo?.[key] ?? '';
            const base = baselineLicense?.[key];
            const highlight =
              mode === 'editable' &&
              scalarEqualsSnapshot(cur, base) &&
              String(cur).length > 0;
            return (
              <Col md={6} key={key}>
                <PrefilledFieldShell
                  label={label}
                  htmlId={`req-draft-license-${key}`}
                  value={cur == null ? '' : String(cur)}
                  type={type || 'text'}
                  mode={mode}
                  highlightPrefilled={highlight}
                  readOnlyReason={mode === 'readOnly' ? 'policy' : undefined}
                  onChange={
                    mode === 'editable'
                      ? (v) => onFieldChange(key, v)
                      : undefined
                  }
                />
              </Col>
            );
          })}
        </Row>
        <div className="small text-muted border-top pt-3 mt-1">
          <span className="fw-semibold text-body">
            License file (snapshot):{' '}
          </span>
          {attLabel}
        </div>
      </Card.Body>
    </Card>
  );
}
